<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <app-filters
          v-model="status_filter"
          :filters="status_filter_options"
          name="filterStatus"
          @change="fetchItems"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default table-default--40"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Item</div></template>
        <template #name="{ row }"><div class="table-default__left">{{ row.item.name }}</div></template>
        <template #planned="{ row }">{{ amountFormat(row.planned_count) }}</template>
        <template #real="{ row }">{{ amountFormat(row.real_count) }}</template>
        <template #given="{ row }">{{ amountFormat(row.given_count) }}</template>
        <template #return="{ row }">{{ amountFormat(row.return_count) }}</template>
        <template #returned="{ row }">{{ amountFormat(row.returned_count) }}</template>
        <template #write_off="{ row }">
          <span
            :style="{ 'backgroundColor': row.write_off ? '#e85c20' : '#77b017' }"
            class="status-tag"
          >
            {{ row.write_off ? 'Yes' : 'No' }}
          </span>
        </template>
        <template #weight="{ row }">{{ amountFormat(row.weight) }}</template>
        <template #controls="{ row }">
          <div class="table-default__controls table-default__controls--minw">
            <button @click="$emit('edit', row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
            </button>
            <button @click="$emit('delete', row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script >
import { getClimbingGroupsEquipmentItems } from '@/http'

export default {
  name: 'ClimbingGroupsSupplyDetailKitchen',
  props: ['status', 'updateKey'],
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: [
          'name',
          'real',
          'given',
          'difference_count',
        ],
        options: {
          headings: {
            'name': 'Item',
            'planned': 'Planned',
            'real': 'Required',
            'given': 'Given',
            'difference_count': 'Difference',
            'return': 'Return',
            'returned': 'Returned',
            'weight': 'Weight',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      status_filter: '',
      status_filter_options: [
        { value: 'pending', label: 'Pending' },
        { value: '', label: 'All' },
      ],
    }
  },
  computed: {
    can_update() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager') ||
        this.$store.state.userGroups.some(group => group.code === 'climbing_supervisor')
    }
  },
  watch: {
    updateKey() {
      this.fetchItems()
    }
  },
  created() {
    this.fetchItems()
    if (this.status === 'finish') this.table.columns.push('return', 'returned')
    if (this.status === 'start') this.table.columns.push('weight')
    if (this.can_update) {
      this.table.columns.splice(1, 0, 'planned')
      this.table.columns.push('controls')
    }
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getClimbingGroupsEquipmentItems(
        Number(this.$route.params.id),
        { page: this.pagination.page, page_size: 40, section: 'kitchen-equipment', status: this.status_filter }
      )
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
      this.page_loaded = true
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    amountFormat(amount) {
      return Intl.NumberFormat('ru-RU').format(amount)
    },
  }
}
</script>

